import { useRef, useState } from "react";
import HeroSection from "./components/HeroSection";
import "./App.css";
import About from "./components/About";
import Experience from "./components/Experience";
import Project from "./components/Project";
import Footer from "./components/Footer";
import ToolTip from "./components/ToolTip";
import LinkPreview from "./components/LinkPreview";

const App = () => {
  const [showMenu, setShowMenu] = useState(false);
  const aboutRef = useRef(null);
  const expRef = useRef(null);
  const projectRef = useRef(null);
  const contactRef = useRef(null);
  const linkPreviewRef = useRef(null);

  const scrollToSection = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="app" onClick={() => setShowMenu(false)}>
      <div className="profiles">
        <ToolTip
          platform="linkedin"
          url="https://www.linkedin.com/in/amitrai50/"
          src="https://cdn4.iconfinder.com/data/icons/social-icons-16/512/LinkedIn_alt-1024.png"
        />
        <ToolTip
          platform="leetcode"
          url="https://leetcode.com/amit_rai/"
          src="https://cdn.iconscout.com/icon/free/png-512/free-leetcode-3628297-3031905.png?f=webp&w=512"
        />
        <ToolTip
          platform="github"
          url="https://github.com/amitrai011"
          src="https://img.icons8.com/?size=100&id=12598&format=png"
        />
        <ToolTip
          platform="twitter"
          url="https://twitter.com/amitrai_dev"
          src="https://cdn.iconscout.com/icon/free/png-512/free-twitter-9420782-7651212.png?f=webp&w=512"
        />
        <ToolTip
          platform="medium"
          url="https://medium.com/@amitrai_dev"
          src="https://cdn.iconscout.com/icon/free/png-512/free-medium-4670123-3878243.png?f=webp&w=512"
        />

        <div className="line"></div>
      </div>
      <div className="home">
        <header className="header">
          <div className="headerLeft">
            <iframe
              src="https://lottie.host/embed/15138fc5-0071-4d1d-aa89-958be4556da1/2w8cq5pEPA.json"
              title="Profile"
              style={{
                width: "6rem",
                height: "6rem",
                marginTop: "10px",
                border: "none",
              }}
            ></iframe>
          </div>
          <nav className="navbar">
            <ul>
              <li onClick={() => scrollToSection(aboutRef)}>
                <span style={{ color: "white" }}>👨🏻‍💻</span> About
              </li>
              <li onClick={() => scrollToSection(expRef)}>
                <span style={{ color: "white" }}>💡</span> Experience
              </li>
              <li onClick={() => scrollToSection(projectRef)}>
                <span style={{ color: "white" }}>🚀</span> Projects
              </li>
              <li onClick={() => scrollToSection(linkPreviewRef)}>
                <span style={{ color: "white" }}>📚</span> Blogs
              </li>
              <li onClick={() => scrollToSection(contactRef)}>
                <span style={{ color: "white" }}>💬</span> Contact
              </li>
            </ul>
          </nav>
          <div
            className="menu"
            onClick={(event) => {
              setShowMenu(!showMenu);
              event.stopPropagation();
            }}
          >
            <img
              src="https://cdn-icons-png.flaticon.com/128/10993/10993281.png"
              alt="Menu"
            />
            {showMenu && (
              <div style={{ height: "14.5rem" }}>
                <p onClick={() => scrollToSection(aboutRef)}>About</p>
                <p onClick={() => scrollToSection(expRef)}>Experience</p>
                <p onClick={() => scrollToSection(projectRef)}>Project</p>
                <p onClick={() => scrollToSection(linkPreviewRef)}>Blogs</p>
                <p onClick={() => scrollToSection(contactRef)}>Contact</p>
                <p
                  onClick={() =>
                    window.open(
                      "https://drive.google.com/file/d/15C3bM-h_tyfOEujzz3CgjPahkxA2wvs0/view",
                      "_blank"
                    )
                  }
                >
                  Resume
                </p>
              </div>
            )}
          </div>
        </header>

        <section id="home">
          <HeroSection />
        </section>
        <section id="about" ref={aboutRef}>
          <About />
        </section>
        <section id="experience" ref={expRef}>
          <Experience />
        </section>
        <section id="project" ref={projectRef}>
          <Project />
        </section>
        <section id="linkPreview" ref={linkPreviewRef}>
          <LinkPreview />
        </section>
        <section id="contact" ref={contactRef}>
          <Footer />
        </section>
      </div>
    </div>
  );
};

export default App;
